/**
 * English language pack
 * Translated using Tencent TMT Translation API
 */
export default {
  app: {
    logo: 'TikiBox',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    confirmLogout: 'Are you sure you want to logout?',
    cancel: 'Cancel',
    confirm: 'Confirm',
    welcome: 'Welcome',
    myOrders: 'My Orders',
    myFavorites: 'My Favorites',
    shoppingCart: 'Shopping Cart',
    home: 'Home',
    allGoods: 'All Products',
    luckyWheel: 'Lucky Wheel',
    aboutUs: 'About Us',
    search: 'Search...',
    footer: {
      sevenDayReturn: '7-Day No-Reason Return',
      freeShipping: 'Free Shipping on Orders Over $99',
      qualityAssurance: '100% Quality Guarantee',
      copyright: 'Store Copyright © 2012-2026',
      slogan: 'Your nearby warehouse for quality digital goods at great prices',
      aboutColumnTitle: 'About TikiBox',
      privacy: 'Privacy',
      serviceRefund: 'Service Refund',
      infoTitle: 'Information',
      refundReturnPolicy: 'Refund & Return Policy',
      logisticsPolicy: 'Logistics Policy',
      contactUs: 'Contact Us',
      socialFacebook: 'Facebook',
      socialYoutube: 'YouTube'
    }
  },
  category: {
    phone: 'Phone',
    appliance: 'Appliance',
    accessory: 'Accessory',
    hot: 'Hot',
    tvAudio: 'TV & Audio',
    protectiveCover: 'Protective Cover',
    charger: 'Charger'
  },
  login: {
    title: 'Login',
    username: 'Please enter account',
    password: 'Please enter password',
    button: 'Login',
    usernameRule: 'Please enter username',
    usernameRuleError: 'Start with letter, 5-16 chars, letters/numbers/underscore',
    passwordRule: 'Please enter password',
    passwordRuleError: 'Start with letter, 6-18 chars, letters/numbers/underscore',
    success: 'Login successful',
    failed: 'Login failed',
    agreeRequired: 'Please read and agree to the Terms of Service and Privacy Policy',
    agreePrefix: 'I have read and agree to the ',
    agreeAnd: ' and ',
    serviceAgreementLink: 'Terms of Service',
    privacyPolicyLink: 'Privacy Policy'
  },
  register: {
    title: 'Register',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    button: 'Register',
    usernamePlaceholder: 'Please enter username',
    passwordPlaceholder: 'Please enter password',
    confirmPasswordPlaceholder: 'Please re-enter password',
    usernameRule: 'Please enter username',
    usernameRuleError: 'Start with letter, 5-16 chars, letters/numbers/underscore',
    passwordRule: 'Please enter password',
    passwordRuleError: 'Start with letter, 6-18 chars, letters/numbers/underscore',
    confirmRule: 'Passwords do not match',
    success: 'Registration successful',
    failed: 'Registration failed',
    exists: 'Username already exists'
  },
  goods: {
    all: 'All Products',
    sort: 'Sort',
    default: 'Default',
    priceAsc: 'Price: Low to High',
    priceDesc: 'Price: High to Low',
    salesDesc: 'Sales: High to Low',
    noResults: 'No products found',
    addToCart: 'Add to Cart',
    addSuccess: 'Added to cart',
    viewDetails: 'View Details'
  },
  details: {
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    productDetails: 'Product Details',
    specs: 'Specifications',
    selectSpec: 'Please select specifications',
    stock: 'Stock',
    reviews: 'Reviews',
    noReviews: 'No reviews yet',
    relatedProducts: 'Related Products'
  },
  cart: {
    title: 'Shopping Cart',
    empty: 'Shopping cart is empty',
    total: 'Total',
    totalPrice: 'Total Price',
    goShopping: 'Go Shopping',
    selected: 'Selected',
    items: 'items',
    remove: 'Remove',
    clearInvalid: 'Clear invalid items',
    settle: 'Checkout',
    allSelected: 'Select All',
    invalid: 'Invalid',
    lineSubtotal: 'Subtotal',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Deletion failed'
  },
  order: {
    title: 'My Orders',
    all: 'All Orders',
    pending: 'Pending Payment',
    paid: 'Paid',
    shipped: 'Shipping',
    completed: 'Completed',
    cancelled: 'Cancelled',
    noOrders: 'No orders yet',
    orderNumber: 'Order Number',
    orderTime: 'Order Time',
    totalAmount: 'Total Amount',
    status: 'Order Status',
    action: 'Action',
    pay: 'Pay',
    confirmReceive: 'Confirm Receipt',
    viewDetails: 'View Details'
  },
  confirmOrder: {
    title: 'Confirm Order',
    shippingAddress: 'Shipping Address',
    addAddress: 'Add New Address',
    useDefault: 'Use Default Address',
    productInfo: 'Product Info',
    totalAmount: 'Order Total',
    freight: 'Freight',
    total: 'Total',
    submitOrder: 'Submit Order',
    payNow: 'Pay Now',
    orderSuccess: 'Order submitted successfully',
    orderFailed: 'Order submission failed',
    invoice: 'Invoice Info',
    electronicInvoice: 'Electronic Invoice',
    personal: 'Personal'
  },
  collect: {
    title: 'My Favorites',
    empty: 'No favorite products yet',
    goShopping: 'Go Shopping',
    removeCollect: 'Remove from Favorites',
    removeSuccess: 'Removed from favorites'
  },
  about: {
    title: 'About Us',
    description: 'TikiBox is an online store dedicated to providing you with high-quality products. We are committed to offering our users a safe, convenient, and premium shopping experience.'
  },
  policy: {
    returnTitle: 'Return & Exchange Policy',
    returnSubtitle: 'Return & Exchange Terms',
    returnItem1: 'Within 7 days after signing for the delivery, you can apply for a no-reason return if the product is intact and does not affect secondary sales.',
    returnItem2: 'For quality issues (such as damage, malfunction, etc.), you can apply for return or exchange, with shipping costs covered by the seller.',
    returnItem3: 'Return/exchange applications must be submitted on the order details page. Refunds will be processed within 3-5 business days after receiving the product.',
    returnItem4: 'The following situations are not eligible for return/exchange: human damage, custom-made products, damage caused by personal reasons.',
    returnProcess: 'Return Process',
    returnProcessDesc: 'Submit Application → Seller Reviews → Ship Back → Seller Receives → Refund/Exchange',
    shippingTitle: 'Logistics Policy',
    shippingSubtitle: 'Shipping Info',
    shippingItem1: 'Orders over $99 qualify for free shipping.',
    shippingItem2: 'Orders under $99 will incur corresponding shipping fees, which will be shown at checkout.',
    shippingItem3: 'We deliver to most areas nationwide. Remote areas may require longer delivery times.',
    shippingTime: 'Delivery Time',
    shippingTimeDesc: 'Under normal circumstances, orders will be shipped within 1-3 business days and delivered within 3-7 business days. Actual delivery time depends on the shipping address and logistics.',
    qualityTitle: 'Quality Guarantee',
    qualitySubtitle: 'Quality Commitment',
    qualityItem1: 'All products are authentic and have passed strict quality inspections.',
    qualityItem2: 'Product descriptions are accurate and truthful, with transparent pricing and no hidden fees.',
    qualityItem3: 'We provide comprehensive after-sales service with a professional customer service team.',
    qualityItem4: 'If you have any questions about product quality, feel free to contact our customer service team.',
    qualityService: 'Quality Service',
    qualityServiceDesc: 'We are committed to providing you with high-quality products and services. If you encounter any issues during your shopping experience, please do not hesitate to contact our customer service team.',
    privacyTitle: 'Privacy Policy',
    privacyItem1: 'We value your privacy and only collect information necessary to fulfill orders and improve our services.',
    privacyItem2: 'Your personal data is protected by law and will not be sold or disclosed to unrelated third parties.',
    privacyItem3: 'You may view or update your profile in account settings at any time.',
    serviceAgreementTitle: 'Terms of Service',
    serviceAgreementItem1: 'By using this store you agree to these terms and related rules.',
    serviceAgreementItem2: 'Keep your account information accurate; you are responsible for activity under your account.',
    serviceAgreementItem3: 'We may update these terms when necessary; changes will be posted on the site.',
    serviceRefundTitle: 'Service Refund',
    serviceRefundItem1: 'For eligible returns, refunds will be issued to the original payment method.',
    serviceRefundItem2: 'Refunds usually take 3–7 business days, depending on your payment provider.',
    serviceRefundItem3: 'Contact our support team if you need assistance.'
  },
  error: {
    title: 'Oops!',
    message: 'Sorry, something went wrong',
    goHome: 'Go Home',
    retry: 'Retry'
  },
  common: {
    loading: 'Loading...',
    noMore: 'No more',
    success: 'Operation successful',
    failed: 'Operation failed',
    error: 'Error',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    price: 'Price',
    quantity: 'Quantity',
    unit: 'pcs'
  },
  lang: {
    currentLang: 'Language',
    switchToEn: 'English',
    switchToZh: '中文',
    switchToVi: 'Tiếng Việt'
  },
  luckyWheel: {
    title: 'Lucky Wheel',
    start: 'Start',
    startLottery: 'Draw to Win',
    lotteryUsed: 'Already Drawn Today',
    lotteryHint: 'Each user can draw only once per day',
    lotteryUsedHint: 'You have already drawn today, please come back tomorrow',
    confirmLottery: 'Are you sure you want to spend 50,000 VND to draw?',
    confirmTitle: 'Confirm Draw',
    confirm: 'Confirm',
    cancel: 'Cancel',
    prizes: 'Prize List',
    rules: 'Rules',
    prize1: 'iPhone 13',
    prize2: 'AirPods Pro',
    prize3: 'Xiaomi Band',
    prize4: '¥100 Coupon',
    prize5: '¥50 Coupon',
    prize6: '¥10 Coupon',
    congrats: 'Congratulations! You won',
    congratsMessage: 'Please claim your prize in time',
    rule1: 'Each user can participate once per day',
    rule2: 'Please claim your prize in time after winning',
    rule3: 'Coupons are valid for 7 days',
    rule4: 'TikiBox reserves the final right of interpretation'
  }
};
